export default "0880758053dbb05f.svg"